import { render } from "./WebGlStatus.vue?vue&type=template&id=8b1e6d9c&scoped=true"
import script from "./WebGlStatus.vue?vue&type=script&lang=js"
export * from "./WebGlStatus.vue?vue&type=script&lang=js"

import "./WebGlStatus.vue?vue&type=style&index=0&id=8b1e6d9c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1e6d9c"]])

export default __exports__